import { FeedbackTriage } from '@userhub/widget'
import { useLang } from '../i18n'
import { navigate, homePath } from '../lib/router'

/**
 * The userhub feedback triage page (`/feedback-triage`, AB#374): the widget's own full page —
 * ticket list, detail, arbitration and the Azure DevOps section. Niobe only mounts it; the
 * UserhubProvider around the signed-in shell (UserhubShell) gives it its API origin, token and
 * theme. `?ticket=<id>` (an id or a number such as NI3) opens that ticket; the key remounts the
 * page when it changes, since the widget reads it once.
 *
 * Above the widget, the "← All bids" button of the other admin pages leads back to Niobe (AB#429):
 * an admin who lands here from an ADO deep link, or in Desktop, has no browser Back.
 *
 * The wrapper fills the shell's page row with no scroll of its own: a header row, then the widget
 * row, whose list/detail split scrolls internally.
 */
export function FeedbackTriagePage() {
  const { t } = useLang()
  const ticket = new URLSearchParams(window.location.search).get('ticket') || undefined
  return (
    <main className="feedback-triage-page" aria-label={t('feedback_triage')}>
      <div className="feedback-triage-head">
        <button className="rel-back" onClick={() => navigate(homePath)}>
          ← {t('all_bids')}
        </button>
      </div>
      <div className="feedback-triage-body">
        <FeedbackTriage key={ticket} initialTicketId={ticket} />
      </div>
    </main>
  )
}
